import { Directive, inject } from '@angular/core';
import { ExperienceCustomisationService, HiddenFeaturesKeySequence } from '@rma/dashboard/layout/public/api-experience';

const modifierKeys = ['Shift', 'Control', 'Alt', 'Meta'];
const sequence = HiddenFeaturesKeySequence.map((key) => key.toLowerCase());

@Directive({
  selector: '[rmaHiddenFeaturesKeySequence]',
  host: {
    '(window:keydown)': 'onKeydown($event)',
  },
})
export class HiddenFeaturesKeySequenceDirective {
  private readonly experienceCustomisationService = inject(ExperienceCustomisationService);

  private typed: string[] = [];

  public onKeydown(event: KeyboardEvent): void {
    if (!event.key || modifierKeys.includes(event.key)) {
      return;
    }

    this.typed = [...this.typed, event.key.toLowerCase()].slice(-sequence.length);

    if (this.typed.length === sequence.length && this.typed.every((key, index) => key === sequence[index])) {
      this.experienceCustomisationService.toggleHiddenFeatures();
      this.typed = [];
    }
  }
}
